const doc = [({"en":({"js":({"forms":({"attachment_input":({"the_file_was_deleted":"The file was deleted"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;